import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class Issues extends Component {
    constructor() {
        super()
        this.state = {
            issuesList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getissuesList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getissuesList = () => {
        apiService.getIssueslList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        issuesList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.issuesList).map((value,index) => {
            
            return {
                label : this.state.issuesList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Issue"
                options={list}
                onChange={(e) => { (e) ? this.props.issueChange(e) : this.props.issueChange([])}}
                />
            </div>
        )
    }
}
export default Issues


// WEBPACK FOOTER //
// ./src/common/DropDowns/Issues.js